<div class="desktop-width-limiter overview-page page-padding">
  <mat-toolbar>
    <button mat-button class="menu-item" routerLink="/create-ad" title="{{ 'create-ads.hover_title' | translate }}">
      <h1>{{ 'create-ads.title' | translate }}</h1>
    </button>
    <button mat-button class="menu-item active" title="{{ 'ads.hover_title' | translate }}">
      <h1>{{ 'ads.title' | translate }}</h1>
    </button>
    <button mat-button class="menu-item" routerLink="/promos" title="{{ 'promo.hover_title' | translate }}">
      <h1>{{ 'promo.title' | translate }}</h1>
    </button>
  </mat-toolbar>

  @if (!loading && !errorText && myAds.length > 0) {
    <div class="row overview-items">
      @for (ad of myAds; track ad) {
        <div class="col-xs-12 col-sm-6 col-lg-4 overview-item">
          <ad-card [ad]="ad"></ad-card>
        </div>
      }
      <div class="noMoreAds">
        <span class="noMoreAdsLabel">{{ 'ads.noMoreAds' | translate }}</span>
      </div>
    </div>
  }

  @if (!loading && !errorText && myAds.length === 0) {
    <div class="errorText">
      {{'page.noVideos' | translate}}
    </div>
  }

  @if (loading) {
    <div class="loading">
      <mat-progress-spinner class="loading-spinner" [diameter]="250" mode="indeterminate" color="primary">
      </mat-progress-spinner>
      <div class="loading-text"><h1>Starten...</h1></div>
    </div>
  }

</div>